import * as CandidateJobMatchCardReportModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-report-modal.html';
import * as CandidateJobMatchCardScreeningModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-screening-modal.html';
import * as CandidateJobMatchCardImageProctoringInfoModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-image-proctoring-info-modal.html';
import * as CandidateJobMatchCardAssessmentInfoModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-assessment-info-modal.html';
import * as CandidateJobMatchCardMeetingsModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-meetings-modal.html';
import * as CandidateActivityModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidates/candidateCard/candidate-activities-modal.html';
import * as CandidateJobMatchCardNotInterestedModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-not-interested-modal.html';
import * as CandidateJobMatchCardReleasedModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-released-modal.html';
import * as CandidateJobMatchCardDeleteModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-delete-modal.html';
import * as CandidateJobMatchCardNotesModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-notes-modal.html';
import * as CandidateJobMatchCardCommunicationModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-communication-modal.html';
import * as CandidateJobMatchCardAssignRecruiterModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-assign-recruiter-modal.html';
import * as CandidateJobMatchCardMoveModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-move-modal.html';
import * as CandidateJobMatchCardSendAssessmentModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-send-assessment-modal.html';
import * as CandidateJobMatchCardCancelAssessmentModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-cancel-assessment-modal.html';
import * as CandidateJobMatchCardScheduleModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-schedule-modal.html';
import * as CandidateJobMatchCardCancelMeetingModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-cancel-meeting-modal.html';
import * as CandidateJobMatchCardUpdateContactModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-update-contact-modal.html';
import * as CandidateJobMatchCardActionsModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-actions-modal.html';
import * as CandidateJobMatchCardUploadResumeModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-upload-resume-modal.html';
import * as SendAssessmentConfirmResendModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/send-assessment-confirm-resend-modal.html';
var JobMatchActionsService = /** @class */ (function () {
    /*@ngInject*/
    function JobMatchActionsService($uibModal, $timeout, StorageService, assessmentService, alertsAndNotificationsService, $state) {
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.StorageService = StorageService;
        this.assessmentService = assessmentService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.$state = $state;
    }
    JobMatchActionsService.prototype.getReport = function (jobMatchId, assessmentType, isSectionalReport, reportUrl, testInvitationId, context) {
        var ctrl = this;
        // if(_.isNull(reportUrl)) {
        //     this._showAssessmentReportNotGeneratedWarning();
        // } else {
        if (context == 'job-candidates-compare') {
            $(".modal").addClass("job-candidates-compare-modal-extra-large");
        }
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: CandidateJobMatchCardReportModal.default,
            backdrop: 'static',
            windowClass: 'four-dot-five-modal-large',
            controller: ['$uibModalInstance', 'assessmentType', 'jobMatchId', 'isSectionalReport', 'testInvitationId', function ($uibModalInstance, assessmentType, jobMatchId, isSectionalReport, testInvitationId) {
                    var vm = this;
                    vm.jobMatchId = jobMatchId;
                    vm.assessmentType = assessmentType;
                    vm.isSectionalReport = isSectionalReport;
                    vm.testInvitationId = testInvitationId;
                    vm.modalTitle = 'Technical Assessment Report';
                    vm.context = "candidateJobMatchCard";
                    if (assessmentType == 'Value') {
                        vm.modalTitle = 'Value Assessment Report';
                    }
                    vm.closeModal = function () {
                        $uibModalInstance.dismiss('close');
                        if (context == 'job-candidates-compare') {
                            ctrl.$timeout(function () {
                                $(".modal").removeClass("job-candidates-compare-modal-extra-large");
                            }, 600);
                        }
                    };
                }],
            controllerAs: 'reportModal',
            size: 'lg',
            resolve: {
                assessmentType: function () {
                    return assessmentType;
                },
                jobMatchId: function () {
                    return jobMatchId;
                },
                isSectionalReport: function () {
                    return isSectionalReport;
                },
                testInvitationId: function () {
                    return testInvitationId;
                }
            }
        });
        // }
    };
    JobMatchActionsService.prototype.openFeedbackModal = function (feedbackDetails) {
        var vm = this;
        $(".modal").addClass("job-candidates-compare-modal-extra-large");
        var templateUrl = CandidateJobMatchCardScreeningModal.default;
        var callbackType = 'refreshWorkflow';
        var windowTopClass = 'four-dot-five-modal-medium';
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: templateUrl,
            backdrop: 'static',
            keyboard: false,
            windowTopClass: windowTopClass,
            controller: ['$uibModalInstance', 'jobId', 'jobMatchId', 'candidateId', 'feedbackType', 'label', 'context', function ($uibModalInstance, jobId, jobMatchId, candidateId, feedbackType, label, context) {
                    var ctrl = this;
                    ctrl.jobMatchId = jobMatchId;
                    ctrl.jobId = jobId;
                    ctrl.candidateId = candidateId;
                    ctrl.feedbackType = feedbackType;
                    ctrl.label = label;
                    ctrl.context = context;
                    ctrl.closeModal = function () {
                        ctrl.closeModalAndRefresh();
                    };
                    ctrl.closeModalAndRefresh = function () {
                        $uibModalInstance.close('cancel');
                        vm.$timeout(function () {
                            $(".modal").removeClass("job-candidates-compare-modal-extra-large");
                        }, 600);
                    };
                    ctrl.saveCallback = function () {
                        ctrl.closeModalAndRefresh();
                    };
                }],
            controllerAs: 'jobMatchIdModal',
            size: 'lg',
            resolve: {
                jobId: function () {
                    return feedbackDetails.jobId;
                },
                jobMatchId: function () {
                    return feedbackDetails.jobMatchId;
                },
                label: function () {
                    return feedbackDetails.label;
                },
                candidateId: function () {
                    return feedbackDetails.candidateId;
                },
                feedbackType: function () {
                    return feedbackDetails.feedbackType; //Screening/PhoneScreen/Interview
                },
                context: function () {
                    return feedbackDetails.context;
                }
            }
        });
    };
    JobMatchActionsService.prototype._showAssessmentReportNotGeneratedWarning = function () {
        var message = "The report is currently being generated. You will be notified once the report is available.";
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Report generation in progress!</strong></div>",
            message: message,
            className: "zIndex1060",
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            }
        });
    };
    JobMatchActionsService.prototype.openImageProctoringInfoModal = function (activeViolation, techAssessmentReportInfoList) {
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: CandidateJobMatchCardImageProctoringInfoModal.default,
            backdrop: 'static',
            keyboard: false,
            bindToController: true,
            windowTopClass: 'four-dot-five-modal-medium',
            controller: ['$uibModalInstance', 'techAssessmentReportInfoList', 'activeViolation', function ($uibModalInstance, techAssessmentReportInfoList, activeViolation) {
                    var vm = this;
                    vm.activeViolation = activeViolation;
                    vm.techAssessmentReportInfoList = techAssessmentReportInfoList;
                    vm.closeModal = function () {
                        $uibModalInstance.close('cancel');
                    };
                }],
            controllerAs: 'imageProctoringInfoModal',
            size: 'lg',
            resolve: {
                activeViolation: function () {
                    return activeViolation;
                },
                techAssessmentReportInfoList: function () {
                    return techAssessmentReportInfoList;
                }
            }
        });
    };
    JobMatchActionsService.prototype.openAssessmentInfoModal = function (jobMatchId, assessmentType) {
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: CandidateJobMatchCardAssessmentInfoModal.default,
            backdrop: 'static',
            keyboard: false,
            bindToController: true,
            windowTopClass: 'four-dot-five-modal-extra-large',
            controller: ['$uibModalInstance', 'jobMatchId', 'assessmentType', function ($uibModalInstance, jobMatchId, assessmentType) {
                    var vm = this;
                    vm.jobMatchId = jobMatchId;
                    vm.assessmentType = assessmentType;
                    vm.title = 'Technical Assessment Info';
                    if (vm.assessmentType == 'Value Assessment') {
                        vm.title = 'Value Assessment Info';
                    }
                    vm.closeModal = function () {
                        $uibModalInstance.close('cancel');
                    };
                }],
            controllerAs: 'assessmentInfoModal',
            size: 'lg',
            resolve: {
                jobMatchId: function () {
                    return jobMatchId;
                },
                assessmentType: function () {
                    return assessmentType;
                }
            }
        });
    };
    JobMatchActionsService.prototype.openMeetingsModal = function (jobMatchId, meetingType, refreshCallback) {
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: CandidateJobMatchCardMeetingsModal.default,
            backdrop: 'static',
            keyboard: false,
            bindToController: true,
            windowTopClass: 'four-dot-five-modal-large',
            controller: ['$uibModalInstance', 'jobMatchId', 'meetingType', function ($uibModalInstance, jobMatchId, meetingType) {
                    var vm = this;
                    vm.jobMatchId = jobMatchId;
                    vm.meetingType = meetingType;
                    vm.title = 'Interviews';
                    if (vm.meetingType == 'PhoneScreen') {
                        vm.title = 'Phone Screens';
                    }
                    vm.closeModal = function () {
                        $uibModalInstance.close('cancel');
                    };
                    vm.saveCallback = function () {
                        refreshCallback();
                    };
                }],
            controllerAs: 'jobMatchMeetingsModal',
            size: 'lg',
            resolve: {
                jobMatchId: function () {
                    return jobMatchId;
                },
                meetingType: function () {
                    return meetingType;
                }
            }
        });
    };
    JobMatchActionsService.prototype.showAllActivityModal = function (jobMatch, jobMatchId, activityMap) {
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: CandidateActivityModal.default,
            windowClass: 'candidate-activities-modal-window',
            backdrop: 'static',
            controller: ['$uibModalInstance', 'candidateInfo', 'jobMatchId', 'activityMap', function ($uibModalInstance, candidateInfo, jobMatchId, activityMap) {
                    var vm = this;
                    vm.candidateInfo = candidateInfo;
                    vm.jobMatchId = jobMatchId;
                    vm.activityMap = activityMap;
                    vm.closeModal = function () {
                        $uibModalInstance.close('cancel');
                    };
                }],
            controllerAs: 'activityModal',
            size: 'lg',
            resolve: {
                candidateInfo: function () {
                    return jobMatch;
                },
                jobMatchId: function () {
                    return jobMatchId;
                },
                activityMap: function () {
                    return activityMap;
                }
            }
        });
    };
    JobMatchActionsService.prototype.performAction = function (context, actionObject, jobMatch, refreshCallback, removeOrRefreshCardCallback) {
        if (!actionObject.allowed) {
            var message = _.isNull(actionObject.message) ? 'This Action is not allowed.' : actionObject.message;
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Action Not Allowed!</strong></div>",
                message: message,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                }
            });
        }
        else {
            var actionType = actionObject.actionType;
            var label = actionObject.action;
            switch (actionType) {
                case 'NOT_INTERESTED':
                case 'RELEASE':
                case 'DELETE_JOBMATCH':
                    this._launchSetStatusModal(context, actionObject, label, jobMatch, refreshCallback, removeOrRefreshCardCallback);
                    break;
                case 'START_SCREENING':
                // this._openConferenceScreen(context, actionType, label, jobMatch, refreshCallback, removeOrRefreshCardCallback);
                // break;
                case 'NOTES':
                case 'COMMUNICATION':
                case 'PEER_COMMUNICATION':
                case 'PHONE_SCREEN_FEEDBACK':
                case 'INTERVIEW_FEEDBACK':
                case 'PHONE_SCREEN_FEEDBACK_FROM_MEETING_POPUP':
                case 'INTERVIEW_FEEDBACK_FROM_MEETING_POPUP':
                case 'MOVE_BACKWARD':
                case 'MOVE_FORWARD':
                case 'ASSIGN_RECRUITER':
                case 'SEND_TECHNICAL_ASSESSMENT':
                case 'SEND_VALUE_ASSESSMENT':
                case 'RE_SEND_TECHNICAL_ASSESSMENT':
                case 'RE_SEND_VALUE_ASSESSMENT':
                case 'CANCEL_TECHNICAL_ASSESSMENT':
                case 'CANCEL_VALUE_ASSESSMENT':
                case 'SCHEDULE_PHONE_SCREEN':
                case 'MODIFY_PHONE_SCREEN':
                case 'SCHEDULE_INTERVIEW':
                case 'MODIFY_INTERVIEW':
                case 'CANCEL_PHONE_SCREEN':
                case 'CANCEL_INTERVIEW':
                case 'UPDATE_CONTACT':
                case 'CANDIDATE_JOB_COMPARE':
                case 'CANDIDATE_PROFILE':
                case 'SKIP_RECRUITER_SCREENING':
                case 'SKIP_TECHNICAL_ASSESSMENT':
                case 'SKIP_VALUE_ASSESSMENT':
                case 'SKIP_PHONE_SCREEN':
                case 'SKIP_INTERVIEW':
                case 'EXPORT_CANDIDATE_INFO':
                case 'UPLOAD_RESUME':
                case 'CANDIDATE_BOOKLET':
                case 'SEND_EMAIL':
                case 'CLIENT_REVIEW':
                    this.setDataAndLaunchJobMatchIdModal(context, actionType, label, jobMatch, actionObject, refreshCallback, removeOrRefreshCardCallback);
                    break;
                default:
                //do nothing
            }
        }
    };
    JobMatchActionsService.prototype._openConferenceScreen = function (context, actionType, label, jobMatch, refreshCallback, removeOrRefreshCardCallback) {
        switch (actionType) {
            case 'START_SCREENING':
                var absUrl = this.StorageService.get('baseurl') + '/#/conference?jm=' + jobMatch.jobMatchId + '&ws=rs&m=PHONE';
                window.open(absUrl, '_blank');
                break;
        }
    };
    JobMatchActionsService.prototype._launchSetStatusModal = function (context, actionObject, modalType, jobMatch, refreshCallback, removeOrRefreshCardCallback) {
        var templateUrl = '';
        var statusType = '';
        var windowTopClass = 'four-dot-five-modal-large';
        switch (modalType) {
            case 'Not Interested':
                templateUrl = CandidateJobMatchCardNotInterestedModal.default;
                statusType = 'Not Interested';
                break;
            case 'Release':
                templateUrl = CandidateJobMatchCardReleasedModal.default;
                statusType = 'Release';
                break;
            case 'Delete Job Match':
                templateUrl = CandidateJobMatchCardDeleteModal.default;
                statusType = 'Delete Job Match';
                break;
        }
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: templateUrl,
            backdrop: 'static',
            keyboard: false,
            windowTopClass: windowTopClass,
            controller: ['$uibModalInstance', 'jobMatchDetailsArray', 'statusType', 'workflowStepName', 'formalizeActivityPayload', function ($uibModalInstance, jobMatchDetailsArray, statusType, workflowStepName, formalizeActivityPayload) {
                    var vm = this;
                    vm.jobMatchDetailsArray = jobMatchDetailsArray;
                    vm.statusType = statusType;
                    vm.workflowStepName = workflowStepName;
                    vm.formalizeActivityPayload = formalizeActivityPayload;
                    vm.saveCallback = function () {
                        $uibModalInstance.close('cancel');
                        vm.refreshCallback();
                    };
                    vm.closeModal = function () {
                        $uibModalInstance.close('cancel');
                    };
                    vm.refreshCallback = function () {
                        if (statusType == 'Delete Job Match' && context == "candidateJobMatches") {
                            removeOrRefreshCardCallback();
                        }
                        else {
                            refreshCallback();
                        }
                    };
                }],
            controllerAs: 'setStatusModal',
            size: 'lg',
            resolve: {
                jobMatchDetailsArray: function () {
                    var tempArray = [];
                    var tempObject = {};
                    tempObject.jobMatchId = jobMatch.jobMatchId;
                    tempObject.candidateId = jobMatch.id;
                    tempObject.workflowStepName = jobMatch.currentStep;
                    tempArray.push(tempObject);
                    return tempArray;
                },
                statusType: function () {
                    return statusType;
                },
                workflowStepName: function () {
                    return jobMatch.currentStep;
                },
                formalizeActivityPayload: function () {
                    return actionObject.formalizeActivityPayload;
                }
            }
        });
    };
    JobMatchActionsService.prototype.setDataAndLaunchJobMatchIdModal = function (context, modalType, label, jobMatch, actionObject, refreshCallback, removeOrRefreshCardCallback) {
        var templateUrl = '';
        var callbackType = '';
        var windowTopClass = 'four-dot-five-modal-medium';
        switch (modalType) {
            case 'NOTES':
                templateUrl = CandidateJobMatchCardNotesModal.default;
                break;
            case 'COMMUNICATION':
                templateUrl = CandidateJobMatchCardCommunicationModal.default;
                break;
            case 'PEER_COMMUNICATION':
                templateUrl = CandidateJobMatchCardCommunicationModal.default;
                windowTopClass = 'four-dot-five-modal-extra-large';
                callbackType = 'refreshJobMatch';
                break;
            case 'ASSIGN_RECRUITER':
                templateUrl = CandidateJobMatchCardAssignRecruiterModal.default;
                callbackType = 'refreshJobMatch';
                break;
            case 'START_SCREENING':
                templateUrl = CandidateJobMatchCardScreeningModal.default;
                callbackType = 'refreshWorkflow';
                windowTopClass = 'four-dot-five-modal-large';
                break;
            case 'PHONE_SCREEN_FEEDBACK':
            case 'INTERVIEW_FEEDBACK':
            case 'PHONE_SCREEN_FEEDBACK_FROM_MEETING_POPUP':
            case 'INTERVIEW_FEEDBACK_FROM_MEETING_POPUP':
                templateUrl = CandidateJobMatchCardScreeningModal.default;
                callbackType = 'refreshJobMatch';
                break;
            case 'MOVE_FORWARD':
            case 'MOVE_BACKWARD':
                templateUrl = CandidateJobMatchCardMoveModal.default;
                callbackType = 'refreshWorkflow';
                break;
            case 'SEND_TECHNICAL_ASSESSMENT':
            case 'SEND_VALUE_ASSESSMENT':
            case 'RE_SEND_TECHNICAL_ASSESSMENT':
            case 'RE_SEND_VALUE_ASSESSMENT':
                templateUrl = CandidateJobMatchCardSendAssessmentModal.default;
                callbackType = 'refreshJobMatch';
                break;
            case 'CANCEL_TECHNICAL_ASSESSMENT':
            case 'CANCEL_VALUE_ASSESSMENT':
                templateUrl = CandidateJobMatchCardCancelAssessmentModal.default;
                callbackType = 'refreshJobMatch';
                break;
            case 'SCHEDULE_PHONE_SCREEN':
            case 'MODIFY_PHONE_SCREEN':
            case 'SCHEDULE_INTERVIEW':
            case 'MODIFY_INTERVIEW':
                templateUrl = CandidateJobMatchCardScheduleModal.default;
                callbackType = 'refreshJobMatch';
                break;
            case 'CANCEL_PHONE_SCREEN':
            case 'CANCEL_INTERVIEW':
                templateUrl = CandidateJobMatchCardCancelMeetingModal.default;
                callbackType = 'refreshJobMatch';
                break;
            case 'UPDATE_CONTACT':
                templateUrl = CandidateJobMatchCardUpdateContactModal.default;
                callbackType = 'refreshJobMatch';
                break;
            case 'CANDIDATE_JOB_COMPARE':
                templateUrl = CandidateJobMatchCardActionsModal.default;
                windowTopClass = 'four-dot-five-modal-large';
                break;
            case 'CANDIDATE_PROFILE':
                templateUrl = CandidateJobMatchCardActionsModal.default;
                windowTopClass = 'four-dot-five-modal-large';
                break;
            case 'CANDIDATE_BOOKLET':
                templateUrl = CandidateJobMatchCardActionsModal.default;
                windowTopClass = 'four-dot-five-modal-large';
                break;
            case 'EXPORT_CANDIDATE_INFO':
                templateUrl = CandidateJobMatchCardActionsModal.default;
                break;
            case 'SKIP_RECRUITER_SCREENING':
            case 'SKIP_TECHNICAL_ASSESSMENT':
            case 'SKIP_VALUE_ASSESSMENT':
            case 'SKIP_PHONE_SCREEN':
            case 'SKIP_INTERVIEW':
                templateUrl = CandidateJobMatchCardMoveModal.default;
                windowTopClass = 'four-dot-five-modal-small';
                callbackType = 'refreshWorkflow';
                break;
            case 'UPLOAD_RESUME':
                templateUrl = CandidateJobMatchCardUploadResumeModal.default;
                windowTopClass = 'four-dot-five-modal-large';
                callbackType = 'refreshJobMatch';
                break;
            case 'SEND_EMAIL':
                templateUrl = CandidateJobMatchCardActionsModal.default;
                windowTopClass = 'four-dot-five-modal-extra-large';
                callbackType = 'refreshJobMatch';
                break;
            case 'CLIENT_REVIEW':
                templateUrl = CandidateJobMatchCardActionsModal.default;
                windowTopClass = 'four-dot-five-modal-large';
                callbackType = 'refreshJobMatch';
                break;
        }
        if (modalType == 'RE_SEND_TECHNICAL_ASSESSMENT' || modalType == 'RE_SEND_VALUE_ASSESSMENT') {
            this._setAssessmentDataAndLaunchModal(context, modalType, label, templateUrl, windowTopClass, callbackType, jobMatch, refreshCallback, removeOrRefreshCardCallback, actionObject);
        }
        else {
            this.launchActionModal(context, jobMatch, modalType, label, templateUrl, windowTopClass, actionObject, callbackType, refreshCallback, removeOrRefreshCardCallback);
        }
    };
    JobMatchActionsService.prototype._setAssessmentDataAndLaunchModal = function (context, modalType, label, templateUrl, windowTopClass, callbackType, jobMatch, refreshCallback, removeOrRefreshCardCallback, actionObject) {
        var _this = this;
        var assessmentType = 'Technical';
        if (modalType == 'RE_SEND_VALUE_ASSESSMENT') {
            assessmentType = 'Value';
        }
        var assessmentDetailsObject = {};
        var assessmentDetails = {};
        assessmentDetailsObject.jobMatchId = jobMatch.jobMatchId;
        assessmentDetailsObject.assessmentType = assessmentType;
        this.assessmentService.getCandidateAssessmentDetails(assessmentDetailsObject, function (data) {
            assessmentDetails = data;
            assessmentDetails.isSendAssessmentFailed = jobMatch.jobMatchCurrentState.includes("Failed");
            if (!_.isNull(assessmentDetails.expiredDateTime)) {
                assessmentDetails.expiredDateTime = new Date(assessmentDetails.expiredDateTime);
            }
            if (!_.isNull(assessmentDetails.cancelledDateTime)) {
                assessmentDetails.cancelledDateTime = new Date(assessmentDetails.cancelledDateTime);
            }
            if (!_.isNull(assessmentDetails.completedDateTime)) {
                assessmentDetails.completedDateTime = new Date(assessmentDetails.completedDateTime);
            }
            if (!_.isNull(assessmentDetails.sentDateTime)) {
                assessmentDetails.sentDateTime = new Date(assessmentDetails.sentDateTime);
            }
            if (!_.isNull(assessmentDetails.suspendedDateTime)) {
                assessmentDetails.suspendedDateTime = new Date(assessmentDetails.suspendedDateTime);
            }
            if (!_.isNull(assessmentDetails.terminatedDateTime)) {
                assessmentDetails.terminatedDateTime = new Date(assessmentDetails.terminatedDateTime);
            }
            if (!_.isNull(assessmentDetails.testLeftDateTime)) {
                assessmentDetails.testLeftDateTime = new Date(assessmentDetails.testLeftDateTime);
            }
            if (!_.isNull(assessmentDetails.sentDateTime)) {
                assessmentDetails.sentDateTime = new Date(assessmentDetails.sentDateTime);
            }
            var previousStateDateTime = '';
            if (assessmentDetails.assessmentLinkStatus == 'Expired' && !_.isNull(assessmentDetails.expiredDateTime)) {
                previousStateDateTime = assessmentDetails.expiredDateTime;
            }
            else if (assessmentDetails.assessmentLinkStatus == 'Suspended' && !_.isNull(assessmentDetails.suspendedDateTime)) {
                previousStateDateTime = assessmentDetails.suspendedDateTime;
            }
            else if (assessmentDetails.assessmentLinkStatus == 'Terminated' && !_.isNull(assessmentDetails.terminatedDateTime)) {
                previousStateDateTime = assessmentDetails.terminatedDateTime;
            }
            else if (assessmentDetails.assessmentLinkStatus == 'Test Left' && !_.isNull(assessmentDetails.testLeftDateTime)) {
                previousStateDateTime = assessmentDetails.testLeftDateTime;
            }
            else if (assessmentDetails.assessmentLinkStatus == 'Complete' && !_.isNull(assessmentDetails.completedDateTime)) {
                previousStateDateTime = assessmentDetails.completedDateTime;
            }
            else {
                previousStateDateTime = assessmentDetails.sentDateTime;
            }
            assessmentDetails.sendAssessmentsCount = assessmentDetails.sendAssessmentsCount + 1;
            if (assessmentDetails.assessmentLinkStatus == 'Expired') {
                var notes = "";
                _this.launchActionModal(context, jobMatch, modalType, label, templateUrl, windowTopClass, callbackType, refreshCallback, removeOrRefreshCardCallback, notes);
            }
            else {
                var ctrl = _this;
                _this.$uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    template: SendAssessmentConfirmResendModal.default,
                    backdrop: 'static',
                    keyboard: false,
                    controller: ['$uibModalInstance', 'assessmentDetails', 'previousStateDateTime', 'closeCallback', 'formalizeActivityPayload', function ($uibModalInstance, assessmentDetails, previousStateDateTime, closeCallback, formalizeActivityPayload) {
                            var vm = this;
                            vm.assessmentDetails = assessmentDetails;
                            vm.label = 'Confirm Re-send';
                            vm.previousStateDateTime = previousStateDateTime;
                            vm.formalizeActivityPayload = formalizeActivityPayload;
                            vm.resendAction = function (resendFlag) {
                                $uibModalInstance.dismiss('cancel');
                                if (resendFlag) {
                                    closeCallback(vm.resendReason, vm.otherReasonNotes);
                                }
                            };
                            vm.receiveFormalizedComment = function (event) {
                                vm.otherReasonNotes = event;
                            };
                            vm.onVoiceTranscript = function (transcript) {
                                if (vm.otherReasonNotes) {
                                    vm.otherReasonNotes += ' ' + transcript;
                                }
                                else {
                                    vm.otherReasonNotes = transcript;
                                }
                            };
                        }],
                    controllerAs: 'resendConfirmationModal',
                    size: 'lg',
                    resolve: {
                        assessmentDetails: function () {
                            return assessmentDetails;
                        },
                        closeCallback: function () {
                            return function (reason, otherReasonNotes) {
                                if (!_.isUndefined(reason)) {
                                    var notes = "";
                                    if (reason != 'Other') {
                                        notes = reason;
                                    }
                                    else if (!_.isUndefined(otherReasonNotes)) {
                                        notes = otherReasonNotes;
                                    }
                                    _this.launchActionModal(context, jobMatch, modalType, label, templateUrl, windowTopClass, callbackType, refreshCallback, removeOrRefreshCardCallback, notes);
                                }
                            };
                        },
                        previousStateDateTime: function () {
                            return previousStateDateTime;
                        },
                        formalizeActivityPayload: function () {
                            return actionObject.formalizeActivityPayload;
                        }
                    }
                });
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    JobMatchActionsService.prototype.launchActionModal = function (context, jobMatch, modalType, label, templateUrl, windowTopClass, actionObject, callbackType, refreshCallback, removeOrRefreshCardCallback, notes) {
        var _this = this;
        var workflowStep = "";
        if (modalType == 'PHONE_SCREEN_FEEDBACK' || jobMatch.currentStep == 'Phone Screen') {
            workflowStep = "ps";
        }
        else if (modalType == 'INTERVIEW_FEEDBACK' || jobMatch.currentStep == 'Interview') {
            workflowStep = "in";
        }
        else if (modalType == 'START_SCREENING') {
            workflowStep = "rs";
        }
        if (context === "associateCandidates") {
            $(".modal").addClass("associate-candidate-modal");
        }
        else if (context === "reviewCandidatePull" || context === "uploadResumes") {
            $(".modal").addClass("review-candidate-pull-modal");
        }
        this.$timeout(function () {
            _this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                template: templateUrl,
                backdrop: 'static',
                keyboard: false,
                windowTopClass: windowTopClass,
                controller: ['$uibModalInstance', 'jobMatchId', 'candidateId', 'jobId', 'modalType', 'label', 'primaryRecruiter', 'candidateJobMatch', 'isSharedRequisition', 'corporateCompanyId', 'corporateCompanyName', 'clientOrBUName', 'jobMatchInfo', 'notes', 'workflowStep', 'candidateDetails', 'clientReviewDetails', 'formalizeActivityPayload', function ($uibModalInstance, jobMatchId, candidateId, jobId, modalType, label, primaryRecruiter, candidateJobMatch, isSharedRequisition, corporateCompanyId, corporateCompanyName, clientOrBUName, jobMatchInfo, notes, workflowStep, candidateDetails, clientReviewDetails, formalizeActivityPayload) {
                        var ctrl = this;
                        ctrl.jobMatchId = jobMatchId;
                        ctrl.jobId = jobId;
                        ctrl.jobMatchIdArray = [];
                        ctrl.jobMatchIdArray.push(ctrl.jobMatchId);
                        ctrl.candidateId = candidateId;
                        ctrl.recruiterId = !_.isUndefined(primaryRecruiter) ? primaryRecruiter.id : undefined;
                        ctrl.modalType = modalType;
                        ctrl.candidateJobMatch = candidateJobMatch;
                        ctrl.label = label;
                        ctrl.isSharedRequisition = isSharedRequisition;
                        ctrl.corporateCompanyId = corporateCompanyId;
                        ctrl.corporateCompanyName = corporateCompanyName;
                        ctrl.clientOrBUName = clientOrBUName;
                        ctrl.jobMatchInfo = jobMatchInfo;
                        ctrl.notes = notes;
                        ctrl.workflowStep = workflowStep;
                        ctrl.moveType = 'Forward';
                        ctrl.isRefreshedDone = false;
                        ctrl.candidateDetails = candidateDetails;
                        ctrl.clientReviewDetails = clientReviewDetails;
                        ctrl.formalizeActivityPayload = formalizeActivityPayload;
                        if (ctrl.modalType == 'MOVE_BACKWARD') {
                            ctrl.moveType = 'Backward';
                        }
                        else if (ctrl.modalType == "SKIP_RECRUITER_SCREENING" || ctrl.modalType == "SKIP_TECHNICAL_ASSESSMENT" || ctrl.modalType == "SKIP_VALUE_ASSESSMENT" || ctrl.modalType == "SKIP_PHONE_SCREEN" || ctrl.modalType == "SKIP_INTERVIEW") {
                            ctrl.moveType = 'Skip';
                        }
                        ctrl.assessmentType = 'Technical';
                        ctrl.assessmentSendMode = 'send';
                        if (ctrl.modalType == 'SEND_VALUE_ASSESSMENT' || ctrl.modalType == 'CANCEL_VALUE_ASSESSMENT' || ctrl.modalType == 'RE_SEND_VALUE_ASSESSMENT') {
                            ctrl.assessmentType = 'Value';
                        }
                        if (ctrl.modalType == 'RE_SEND_TECHNICAL_ASSESSMENT' || ctrl.modalType == 'RE_SEND_VALUE_ASSESSMENT') {
                            ctrl.assessmentSendMode = 'resend';
                        }
                        ctrl.scheduleType = 'phoneScreen';
                        if (ctrl.modalType == 'SCHEDULE_INTERVIEW' || ctrl.modalType == 'MODIFY_INTERVIEW' || ctrl.modalType == 'CANCEL_INTERVIEW') {
                            ctrl.scheduleType = 'interview';
                        }
                        ctrl.scheduleMode = 'add';
                        if (ctrl.modalType == 'MODIFY_PHONE_SCREEN' || ctrl.modalType == 'MODIFY_INTERVIEW') {
                            ctrl.scheduleMode = 'edit';
                        }
                        ctrl.feedbackType = 'Screening';
                        if (ctrl.modalType == 'INTERVIEW_FEEDBACK' || ctrl.modalType == 'INTERVIEW_FEEDBACK_FROM_MEETING_POPUP') {
                            ctrl.feedbackType = 'Interview';
                        }
                        else if (ctrl.modalType == 'PHONE_SCREEN_FEEDBACK' || ctrl.modalType == 'PHONE_SCREEN_FEEDBACK_FROM_MEETING_POPUP') {
                            ctrl.feedbackType = 'PhoneScreen';
                        }
                        if (ctrl.modalType == 'COMMUNICATION') {
                            ctrl.communicationType = 'candidate';
                        }
                        else if (ctrl.modalType == 'PEER_COMMUNICATION') {
                            ctrl.communicationType = 'peer';
                        }
                        ctrl.closeModal = function () {
                            if (ctrl.modalType == 'UPLOAD_RESUME' && !ctrl.isRefreshDone) {
                                ctrl.closeModalAndRefresh();
                            }
                            else {
                                $uibModalInstance.close('cancel');
                            }
                        };
                        ctrl.closeModalAndRefresh = function () {
                            $uibModalInstance.close('cancel');
                            ctrl.refreshCallback();
                        };
                        ctrl.saveCallback = function () {
                            if (ctrl.modalType != 'UPDATE_CONTACT') {
                                $uibModalInstance.close('cancel');
                            }
                            ctrl.refreshCallback();
                        };
                        ctrl.refreshCallback = function () {
                            ctrl.isRefreshDone = true;
                            if (context == 'candidateJobMatchCard') {
                                if (callbackType == 'refreshJobMatch') {
                                    removeOrRefreshCardCallback();
                                }
                                else if (callbackType == 'refreshWorkflow') {
                                    refreshCallback();
                                }
                            }
                            else if (context == 'candidateJobMatches') {
                                refreshCallback();
                            }
                            //check
                        };
                    }],
                controllerAs: 'jobMatchIdModal',
                size: 'lg',
                resolve: {
                    jobMatchId: function () {
                        return jobMatch.jobMatchId;
                    },
                    modalType: function () {
                        return modalType;
                    },
                    label: function () {
                        return label;
                    },
                    candidateId: function () {
                        return jobMatch.id;
                    },
                    candidateJobMatch: function () {
                        return jobMatch;
                    },
                    primaryRecruiter: function () {
                        return jobMatch.primaryRecruiter;
                    },
                    jobId: function () {
                        return jobMatch.jobMatchJobId;
                    },
                    isSharedRequisition: function () {
                        return jobMatch.isSharedRequisition;
                    },
                    corporateCompanyId: function () {
                        return jobMatch.corporateCompanyId;
                    },
                    corporateCompanyName: function () {
                        return jobMatch.corporateCompanyName;
                    },
                    clientOrBUName: function () {
                        return jobMatch.clientOrBUName;
                    },
                    jobMatchInfo: function () {
                        return jobMatch;
                    },
                    notes: function () {
                        return notes;
                    },
                    workflowStep: function () {
                        return workflowStep;
                    },
                    candidateDetails: function () {
                        return actionObject.candidateDetails;
                    },
                    clientReviewDetails: function () {
                        return actionObject.clientReviewDetails;
                    },
                    formalizeActivityPayload: function () {
                        return actionObject.formalizeActivityPayload;
                    }
                }
            });
        }, 300);
    };
    JobMatchActionsService.prototype._setCandidateInfoInEmailBody = function (candidate, candidateAdditionalDetails) {
        var _this = this;
        var candidateInformation = [];
        var candidateInformationList = ['Full Name', 'Phone Number', 'Email', 'Address', 'Current Role', 'Current Company', 'Seeking Job Type', 'Desired Salary/Rate', 'Sponsorship', 'Sponsorship Notes', 'Preferred Work Locations', 'Willing To Relocate', 'Linkedin Url', 'Additional Information'];
        candidateInformationList.map(function (val) {
            var tempInformation = {};
            tempInformation.id = 'id' + val;
            tempInformation.name = val;
            tempInformation.value = _this._setCandidateInformationObject(val, candidate, candidateAdditionalDetails);
            if (tempInformation.value && tempInformation.value != '') {
                candidateInformation.push(tempInformation);
            }
        });
        return candidateInformation;
    };
    JobMatchActionsService.prototype._setCandidateInformationObject = function (val, candidate, candidateAdditionalDetails) {
        var candidateInformation;
        switch (val) {
            case 'Full Name':
                candidateInformation = (candidate.firstName ? (candidate.firstName + " ") : '') + (candidate.lastName ? candidate.lastName : '');
                break;
            case 'Phone Number':
                candidateInformation = candidate.mobilephone;
                break;
            case 'Email':
                candidateInformation = candidate.email;
                break;
            case 'Address':
                var address = '';
                if (candidate.address) {
                    address = address + (candidate.address.address1 ? candidate.address.address1 + ',' : '');
                    address = address + (candidate.address.address2 ? candidate.address.address2 + ',' : '');
                    address = address + (candidate.address.state ? candidate.address.state + ',' : '');
                    address = address + (candidate.address.city ? candidate.address.city.name + ',' : '');
                    address = address + (candidate.address.country ? candidate.address.country + ',' : '');
                    address = address + (candidate.address.zipcode ? candidate.address.zipcode : '');
                }
                candidateInformation = address;
                break;
                // case 'Current Location':
                //     candidateInformation = candidate.currentJobLocation;
                break;
            case 'Current Role':
                candidateInformation = candidate.currentJobTitle;
                break;
            case 'Current Company':
                candidateInformation = candidate.currentJobCompanyName;
                break;
            case 'Seeking Job Type':
                var matchedJobType_1 = '';
                if (candidateAdditionalDetails && candidateAdditionalDetails.requisitionJobType) {
                    if (candidateAdditionalDetails.preferredJobTypeDetails && candidateAdditionalDetails.preferredJobTypeDetails.jobType) {
                        candidateAdditionalDetails.preferredJobTypeDetails.jobType.map(function (jobType) {
                            if (jobType.jobType == candidateAdditionalDetails.requisitionJobType) {
                                matchedJobType_1 = jobType.jobType;
                            }
                        });
                    }
                }
                candidateInformation = matchedJobType_1;
                break;
            case 'Desired Salary/Rate':
                var salaryOrRate = '';
                if (candidateAdditionalDetails && candidateAdditionalDetails.preferredJobTypeDetails) {
                    if (candidateAdditionalDetails.requisitionJobType) {
                        if (candidateAdditionalDetails.requisitionJobType === 'FULLTIME' && candidateAdditionalDetails.preferredJobTypeDetails.salary) {
                            salaryOrRate = salaryOrRate + 'Salary: ' + this._setCandidateSalaryOrRate('salary', candidateAdditionalDetails.preferredJobTypeDetails.salary);
                        }
                        else {
                            if (candidateAdditionalDetails.preferredJobTypeDetails.rate) {
                                salaryOrRate = salaryOrRate + 'Rate: ' + this._setCandidateSalaryOrRate('rate', candidateAdditionalDetails.preferredJobTypeDetails.rate);
                            }
                        }
                    }
                    else {
                        if (candidateAdditionalDetails.preferredJobTypeDetails.salary) {
                            salaryOrRate = salaryOrRate + 'Salary: ' + this._setCandidateSalaryOrRate('salary', candidateAdditionalDetails.preferredJobTypeDetails.salary);
                        }
                        if (candidateAdditionalDetails.preferredJobTypeDetails.rate) {
                            salaryOrRate = (salaryOrRate != '' ? salaryOrRate + '; ' : salaryOrRate) + 'Rate: ' + this._setCandidateSalaryOrRate('rate', candidateAdditionalDetails.preferredJobTypeDetails.rate);
                        }
                    }
                }
                candidateInformation = salaryOrRate;
                break;
            case 'Sponsorship':
                candidateInformation = (candidateAdditionalDetails && candidateAdditionalDetails.sponsorships) ? candidateAdditionalDetails.sponsorships.toString() : '';
                break;
            case 'Sponsorship Notes':
                candidateInformation = candidateAdditionalDetails ? candidateAdditionalDetails.sponsorshipsNote : '';
                break;
            case 'Preferred Work Locations':
                candidateInformation = (candidateAdditionalDetails && candidateAdditionalDetails.preferredWorkLocations) ? candidateAdditionalDetails.preferredWorkLocations
                    .map(function (location) { return location.name; })
                    .join(', ') : '';
                break;
            case 'Willing To Relocate':
                candidateInformation = candidateAdditionalDetails ? candidateAdditionalDetails.willingToRelocate : '';
                break;
            case 'Linkedin Url':
                var linkedinUrl_1 = '';
                if (candidateAdditionalDetails && candidateAdditionalDetails.urls) {
                    candidateAdditionalDetails.urls.map(function (url) {
                        if (url.urlType == 'LinkedIn') {
                            linkedinUrl_1 = url.urlLink;
                        }
                    });
                }
                candidateInformation = linkedinUrl_1;
                break;
            case 'Additional Information':
                candidateInformation = candidateAdditionalDetails ? candidateAdditionalDetails.additionalInformation : '';
                break;
            default:
                break;
        }
        // If value is null, undefined, or empty string, assign 'Not Specified'
        if (!candidateInformation || candidateInformation === '') {
            candidateInformation = 'Not Specified';
        }
        return candidateInformation;
    };
    JobMatchActionsService.prototype._setCandidateSalaryOrRate = function (type, salaryOrRate) {
        var salaryOrRateText = '';
        if (salaryOrRate) {
            if (type == 'salary') {
                if (salaryOrRate.salaryType == 'Range') {
                    salaryOrRateText = salaryOrRate.maxSalary + ' to ' + salaryOrRate.minSalary + " " + salaryOrRate.currency + " " + salaryOrRate.salaryDuration.replace(/_+/g, " ").toLowerCase();
                }
                else {
                    salaryOrRateText = salaryOrRate.maxSalary + " " + salaryOrRate.currency + " " + salaryOrRate.salaryDuration.replace(/_+/g, " ").toLowerCase();
                }
            }
            else {
                if (salaryOrRate.rateType == 'Range') {
                    salaryOrRateText = salaryOrRate.maxRate + ' to ' + salaryOrRate.minRate + " " + salaryOrRate.currency + " " + salaryOrRate.rateDuration.replace(/_+/g, " ").toLowerCase();
                }
                else {
                    salaryOrRateText = salaryOrRate.maxRate + " " + salaryOrRate.currency + " " + salaryOrRate.rateDuration.replace(/_+/g, " ").toLowerCase();
                }
            }
        }
        // If value is null, undefined, or empty string, assign 'Not Specified'
        if (salaryOrRateText === null || salaryOrRateText === undefined || salaryOrRateText === '') {
            salaryOrRateText = 'Not Specified';
        }
        return salaryOrRateText;
    };
    JobMatchActionsService.prototype.openSendOutreachEmailModal = function (jobMatches, isVendorOnly, companyId, userId, candidateId, clientOrBUId, candidateType, salaryDurationOptions, jobTypeList, candidateName, successCallback) {
        var tm = this;
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: CandidateJobMatchCardActionsModal.default,
            backdrop: 'static',
            keyboard: false,
            bindToController: true,
            windowTopClass: 'four-dot-five-modal-large',
            controller: ['$uibModalInstance', '$state', 'actionType', 'jobMatches', 'isVendorOnly', 'label', 'companyId', 'userId', 'candidateId', 'clientOrBUId', 'candidateType', 'salaryDurationOptions', 'jobTypeList', 'candidateName',
                function ($uibModalInstance, $state, actionType, jobMatches, isVendorOnly, label, companyId, userId, candidateId, clientOrBUId, candidateType, salaryDurationOptions, jobTypeList, candidateName) {
                    var vm = this;
                    vm.jobMatches = jobMatches;
                    vm.actionType = actionType;
                    vm.isVendorOnly = isVendorOnly;
                    vm.selectAllJobMatches = false;
                    vm.label = label;
                    vm.companyId = companyId;
                    vm.userId = userId;
                    vm.candidateId = candidateId;
                    vm.clientOrBUId = clientOrBUId;
                    vm.candidateType = candidateType;
                    vm.salaryDurationOptions = salaryDurationOptions;
                    vm.jobTypeList = jobTypeList;
                    vm.candidateName = candidateName;
                    vm.closeModal = function () {
                        $uibModalInstance.close('cancel');
                    };
                    vm.saveCallback = function () {
                        $uibModalInstance.close('cancel');
                        successCallback();
                    };
                    vm.cancelCallback = function () {
                        $uibModalInstance.close('cancel');
                    };
                }],
            controllerAs: 'jobMatchIdModal',
            size: 'lg',
            resolve: {
                jobMatches: function () {
                    return jobMatches;
                },
                actionType: function () {
                    return 'SEND_OUTREACH_EMAIL';
                },
                label: function () {
                    return "Send Outreach to Candidate <b>'" + candidateName + "'</b>";
                },
                isVendorOnly: function () {
                    return isVendorOnly;
                },
                companyId: function () {
                    return companyId;
                },
                userId: function () {
                    return userId;
                },
                candidateId: function () {
                    return candidateId;
                },
                clientOrBUId: function () {
                    return clientOrBUId;
                },
                candidateType: function () {
                    return candidateType;
                },
                salaryDurationOptions: function () {
                    return salaryDurationOptions;
                },
                jobTypeList: function () {
                    return jobTypeList;
                },
                candidateName: function () {
                    return candidateName;
                }
            }
        });
    };
    return JobMatchActionsService;
}());
export { JobMatchActionsService };
//# sourceMappingURL=jobMatchActionsService.js.map